import React from 'react';
import { Button, Form, NavLink } from 'react-bootstrap';
import logo from '../../../assets/img/clarity_logo.png';
import vector from '../../../assets/img/changePassword_vector.svg'
import InputTextFeild from '../form/InputTextFeild';
import SubmitButton from '../form/SubmitButton';
const ChangePasswordFormComponent = ({
    oldPassword,
    newPassword,
    cnfPassword,
    onChange,
    errors,
    isLoading,
    onSubmit
}) => {
    return (
        <>
            <section className='formLeftSection'>
                <div className='glassEffects nextonboarding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-6">
                                <img className='logo' src={logo} />
                                <h2>Change Password</h2>
                                <p>Enter your new passwords below</p>
                                <Form>
                                    <label>Old Password</label>
                                    <InputTextFeild
                                        name="oldPassword" 
                                        type="password" 
                                        placeholder="Enter your old password" 
                                        value={oldPassword} 
                                        onChange={onChange} 
                                        errorMessage={errors && errors.oldPassword ? errors.oldPassword : ''}
                                    />

                                    <label>New Password</label>
                                    <InputTextFeild
                                        name="newPassword" 
                                        type="password" 
                                        placeholder="Enter your new password" 
                                        value={newPassword} 
                                        onChange={onChange} 
                                        errorMessage={errors && errors.newPassword ? errors.newPassword : ''}
                                    />

                                    <label>Confirm Password</label>
                                    <InputTextFeild
                                        name="cnfPassword" 
                                        type="password" 
                                        placeholder="Confirm Password" 
                                        value={cnfPassword}
                                        onChange={onChange}
                                        errorMessage={errors && errors.cnfPassword ? errors.cnfPassword : ''}
                                    />
                                    <div className='buttonSetPassword'>
                                        <Button className='customCancelBtn mt-0' variant="" type="button">
                                            Cancel
                                        </Button>
                                        <SubmitButton
                                            text={'Save'}
                                            isLoading={isLoading}
                                            onSubmit={onSubmit}
                                            className={'customSubmitBtn mt-0'}
                                        >                                            
                                        </SubmitButton>
                                    </div>
                                </Form>
                            </div>
                            <div className="col-md-6 d-none d-md-block image-loader">
                                <div className='h-100 d-flex align-items-center justify-content-center'>
                                    <img className='w-100' src={vector} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>         
        </>
    );
}

export default ChangePasswordFormComponent;